module.exports = __webpack_public_path__ + "img/rsk.3efbc411.svg";